import { Box, Paper, Tab, Tabs, Typography } from "@mui/material"
import { SyntheticEvent, useState } from "react"

import { SysDocumentContentActionByActionView } from "./SysDocumentContentActionByActionView"
import { SysDocumentContentActionRulesSetup } from "./SysDocumentContentActionRulesSetup"

type WorkflowSettingsTab = "document-content-action-rules" | "document-content-action-by-action" | "other"

export const SysWorkflowSettings = () => {
	const [tab, setTab] = useState<WorkflowSettingsTab>(
		"document-content-action-rules"
	)

	const handleTabChange = (_event: SyntheticEvent, newTab: string) => {
		setTab(newTab as WorkflowSettingsTab)
	}

	return (
		<Paper sx={{ p: 1 }}>
			<Tabs
				value={tab}
				onChange={handleTabChange}
				sx={{ mb: 1 }}
			>
				<Tab
					value="document-content-action-rules"
					label="Matryca wg statusu"
				/>
				<Tab
					value="document-content-action-by-action"
					label="Matryca wg akcji"
				/>
				<Tab
					value="other"
					label="Pozostale"
				/>
			</Tabs>

			{tab === "document-content-action-rules" && (
				<SysDocumentContentActionRulesSetup />
			)}

			{tab === "document-content-action-by-action" && (
				<SysDocumentContentActionByActionView />
			)}

			{tab === "other" && (
				<Box sx={{ p: 2 }}>
					<Typography color="text.secondary">
						Miejsce na kolejne ustawienia workflow.
					</Typography>
				</Box>
			)}
		</Paper>
	)
}

export default SysWorkflowSettings

